import { Modal } from "antd";

import { useTranslation } from "react-i18next";

import { formatTime } from "helpers/common";

const JobsiteDetailsModal = ({
  isModalOpen,
  handleOk,
  handleCancel,
  registrationID,
  registrationObj,
}) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <Modal
      title={t("dashboard.jobsiteDetailsModal.modalTitle")}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      key={registrationID}
      width={800}
      footer={null}
    >
      <ul>
        <li style={{ listStyleType: "square", fontWeight: "bold" }}>
          {t("dashboard.assignedCompanyName")}
          <ul>
            <li style={{ fontWeight: "normal" }}>
              {registrationObj?.assignedJobOpportunity?.companyRequest?.[
                `companyName${currentLanguage === "en" ? "En" : "Ar"}`
              ] || "-"}
            </li>
          </ul>
        </li>

        <li style={{ listStyleType: "square", fontWeight: "bold" }}>
          {t("dashboard.assignedJobTitle")}
          <ul>
            <li style={{ fontWeight: "normal" }}>
              {registrationObj?.assignedJobOpportunity?.jobTitle || "-"}
            </li>
          </ul>
        </li>

        <li style={{ listStyleType: "square", fontWeight: "bold" }}>
          {t("dashboard.jobsiteDetailsModal.jobDescription")}
          <ul>
            <li style={{ fontWeight: "normal" }}>
              {registrationObj?.assignedJobOpportunity?.jobDescription || "-"}
            </li>
          </ul>
        </li>

        <li style={{ listStyleType: "square", fontWeight: "bold" }}>
          {t("dashboard.jobsiteDetailsModal.workingHours")}
          <ul>
            <li style={{ fontWeight: "normal" }}>
              {t("dashboard.jobsiteDetailsModal.from")}&nbsp;
              {registrationObj?.assignedJobOpportunity?.startingTime
                ? formatTime(registrationObj?.assignedJobOpportunity?.startingTime, currentLanguage)
                : "-"}
              &nbsp;
              {t("dashboard.jobsiteDetailsModal.to")}&nbsp;
              {registrationObj?.assignedJobOpportunity?.endingTime
                ? formatTime(registrationObj?.assignedJobOpportunity?.endingTime, currentLanguage)
                : "-"}
            </li>
          </ul>
        </li>

        <li style={{ listStyleType: "square", fontWeight: "bold" }}>
          {t("dashboard.jobsiteDetailsModal.workingDays")}
          <ul>
            <li style={{ fontWeight: "normal" }}>
              {registrationObj?.assignedJobOpportunity?.workDays || "-"}
            </li>
          </ul>
        </li>

        <li style={{ listStyleType: "square", fontWeight: "bold" }}>
          {t("dashboard.jobsiteDetailsModal.address")}
          <ul>
            <li
              style={{
                fontWeight: "normal",
              }}
            >
              {registrationObj?.assignedJobOpportunity?.location?.address || "-"}
            </li>
          </ul>
        </li>

        <li style={{ listStyleType: "square", fontWeight: "bold" }}>
          {t("dashboard.jobsiteDetailsModal.supervisorName")}
          <ul>
            <li style={{ fontWeight: "normal" }}>
              {" "}
              {registrationObj?.assignedJobOpportunity?.location?.supervisorName || "-"}
            </li>
          </ul>
        </li>

        <li style={{ listStyleType: "square", fontWeight: "bold" }}>
          {t("dashboard.jobsiteDetailsModal.supervisorNumber")}
          <ul>
            <li style={{ fontWeight: "normal" }}>
              {registrationObj?.assignedJobOpportunity?.location?.supervisorNumber || "-"}
            </li>
          </ul>
        </li>
      </ul>
    </Modal>
  );
};

export default JobsiteDetailsModal;
